import React, { useEffect, useState } from 'react'
import { GetAllLiveAccountsByUserIdApi } from '../../api/request/lp/lpdashboard'
import { useSelector } from 'react-redux';
import MySegmented from '../../components/segmented/Segmented';
import LpTrades from './trade/LpTrades';


function LpDashboard() {
  const { userDetails } = useSelector(state => state.user);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(undefined);

  const getLiveaccounts = async () => {
    try {
      const response = await GetAllLiveAccountsByUserIdApi(userDetails?._id);
      const data = response?.data?.data || [];
      const opts = data.map(item => ({ label: `${item.name} (${item.loginId})`, value: item.loginId }));
      setOptions(opts);
      if (opts.length > 0) setSelected(opts[0].value);
      console.log("Live Accounts Response:", data);
    } catch (error) {
      console.error("Error fetching live accounts:", error);
    }
  };

  useEffect(() => {
    if (userDetails?._id) getLiveaccounts();
  }, [userDetails?._id])

  useEffect(() => {
    if (selected !== undefined) {
      // find the selected option object for more context and log it
      const selectedObj = options.find(o => o.value === selected) || null;
      console.log('Selected LP option:', selectedObj);
    }
  }, [selected, options]);

  return (
    <div className=''>
      {options && options.length > 0 ? (
        <MySegmented options={options} value={selected} setValue={setSelected} />
      ) : (
        <p className='text-sm text-muted'>No live accounts found.</p>
      )}
      {selected !== undefined && (
        <div className="mt-6">
          <LpTrades loginId={selected} />
        </div>
      )}
    </div>
  )
}

export default LpDashboard